<div class="main-content table-page table-page--compact table-page--dense ubicaciones-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Sitios</h1>
        <p>Dónde trabaja su gente y cómo registra en cada lugar.</p>
      </div>
      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="nuevoSitio()">
          <span class="material-icons">add_location_alt</span>
          Nuevo sitio
        </button>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--wide">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Nombre o cliente</mat-label>
              <input matInput aria-label="Nombre o cliente" [(ngModel)]="filtroNombre" (keyup.enter)="consultar()" />
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Tipo</mat-label>
              <mat-select [(ngModel)]="filtroTipo" (selectionChange)="consultar()">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option value="OFICINA_PROPIA">Oficina propia</mat-option>
                <mat-option value="SITIO_CLIENTE">Sitio de cliente</mat-option>
                <mat-option value="HOME_OFFICE">Home office</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Estatus</mat-label>
              <mat-select [(ngModel)]="filtroEstatus" (selectionChange)="consultar()">
                <mat-option value="ACTIVO">Activos</mat-option>
                <mat-option value="INACTIVO">Incluir dados de baja</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="table-page__toolbar-actions">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                  (click)="limpiarFiltros()">
            <span class="material-icons">filter_alt_off</span>
            Limpiar
          </button>
          <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="consultar()">
            <span class="material-icons">search</span>
            Consultar
          </button>
        </div>
      </div>

      <div class="table-page__table-wrap" *ngIf="ubicaciones.length > 0; else sitiosEmptyState">
        <table class="table-page__table">
          <thead>
            <tr>
              <th>Sitio</th>
              <th>Tipo</th>
              <th>Cómo se registra</th>
              <th>Geocerca</th>
              <th>Zona horaria</th>
              <th>Estatus</th>
              <th class="table-page__actions-head table-page__actions--multi">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let sitio of ubicaciones">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ sitio.nombre }}</strong>
                  <span class="table-page__subtext" *ngIf="sitio.nombreCliente">{{ sitio.nombreCliente }}</span>
                </div>
              </td>
              <td><span class="table-page__text">{{ etiquetaTipo(sitio.tipo) }}</span></td>
              <td><span class="table-page__text">{{ etiquetaCanal(sitio.canalRegistro) }}</span></td>
              <td><span class="table-page__text">{{ etiquetaGeocerca(sitio) }}</span></td>
              <td><span class="table-page__text">{{ sitio.zonaHoraria || "—" }}</span></td>
              <td><span [class]="claseEstatus(sitio.estatus)">{{ sitio.estatus }}</span></td>
              <td class="table-page__actions table-page__actions--multi">
                <div class="table-page__action-group">
                  <button type="button" class="table-page__action-btn" title="Editar" aria-label="Editar"
                          (click)="editarSitio(sitio)">
                    <span class="material-icons">edit</span>
                  </button>
                  <button type="button" class="table-page__action-btn table-page__action-btn--danger"
                          title="Dar de baja" aria-label="Dar de baja"
                          *ngIf="esActivo(sitio)" (click)="desactivar(sitio)">
                    <span class="material-icons">block</span>
                  </button>
                  <button type="button" class="table-page__action-btn" title="Reactivar" aria-label="Reactivar"
                          *ngIf="!esActivo(sitio)" (click)="reactivar(sitio)">
                    <span class="material-icons">undo</span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #sitiosEmptyState>
        <div class="table-page__empty" *ngIf="!loading; else sitiosLoadingState">
          <span class="material-icons">place</span>
          <h3>No hay sitios registrados</h3>
          <p>Dé de alta al menos uno: sin sitio, la evaluación no sabe dónde se esperaba a nadie.</p>
        </div>
      </ng-template>

      <ng-template #sitiosLoadingState>
        <div class="table-page__empty table-page__empty--loading">
          <span class="material-icons">hourglass_top</span>
          <h3>Consultando sitios</h3>
          <p>Espere un momento.</p>
        </div>
      </ng-template>
    </section>
  </div>
</div>
